/**
 * Status variants available for the StatusIndicator component.
 */
export const STATUS_VARIANTS = {
  PENDING: 'pending-approval',
  AWAITING: 'awaiting-approval',
  APPROVED: 'approved',
  DISABLED: 'workflow-disabled',
  UNKNOWN: 'unknown-status',
  YES: 'yes',
  NO: 'no',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  OPEN: 'open',
  REJECTED: 'rejected',
  IN_PROGRESS: 'in-progress',
  FAILED: 'failed',
  PENDING_SUBMISSION: 'pending-submission',
  FC_PENDING_APPROVAL: 'fc-pending-approval',
  FC_APPROVED: 'fc-approved',
  FC_REJECTED: 'fc-rejected',
  REGIONAL_PENDING: 'regional-pending',
  REGIONAL_REJECTED: 'regional-rejected',
  REGIONAL_AWAITED: 'regional-awaited',
};

/**
 * Configuration for each status variant (label, color, shadow).
 * Colors reference CSS variables from _colors.scss workflow tokens.
 */
export const STATUS_CONFIG = {
  [STATUS_VARIANTS.PENDING]: {
    label: 'Awaiting Approval',
    color: 'var(--workflow-yellow-local)',
    // shadow: 'rgba(250, 204, 21, 0.35)',
  },
  [STATUS_VARIANTS.AWAITING]: {
    label: 'Awaiting Approval',
    color: 'var(--workflow-yellow-local)',
    // shadow: 'rgba(250, 204, 21, 0.35)',
  },
  [STATUS_VARIANTS.REGIONAL_PENDING]: {
    label: 'Regional Awaiting Approval',
    color: 'var(--workflow-yellow-regional)',
  },
  [STATUS_VARIANTS.REGIONAL_REJECTED]: {
    label: 'Regional Rejected',
    color: 'var(--workflow-red-regional)',
  },
  [STATUS_VARIANTS.REGIONAL_AWAITED]: {
    label: 'Regional Awaited',
    color: 'var(--workflow-blue-regional)',
  },
  [STATUS_VARIANTS.APPROVED]: {
    label: 'Approved',
    color: 'var(--workflow-green)',
    // shadow: 'rgba(34, 197, 94, 0.35)',
  },
  [STATUS_VARIANTS.DISABLED]: {
    label: 'Workflow Disabled',
    color: 'var(--workflow-disabled)',
    // shadow: 'rgba(148, 163, 184, 0.35)',
  },
  [STATUS_VARIANTS.UNKNOWN]: {
    label: 'No Status',
    color: 'var(--workflow-other-text)',
    shadow: 'rgba(100, 116, 139, 0.25)',
  },
   [STATUS_VARIANTS.YES]: {
    label: 'Yes',
    color: 'var(--workflow-green)',
    shadow: 'rgba(100, 116, 139, 0.25)',
  },
   [STATUS_VARIANTS.NO]: {
    label: 'No',
    color: 'var(--workflow-red-local)',
    shadow: 'rgba(100, 116, 139, 0.25)',
  },
  [STATUS_VARIANTS.ACTIVE]: {
    label: 'Active',
    color: 'var(--workflow-green)',
    // shadow: 'rgba(34, 197, 94, 0.35)',
  },
  [STATUS_VARIANTS.INACTIVE]: {
    label: 'Inactive',
    color: 'var(--workflow-disabled)',
    // shadow: 'rgba(148, 163, 184, 0.35)',
  },
  [STATUS_VARIANTS.OPEN]: {
    label: 'Open',
    color: 'var(--workflow-blue-local)',
    // shadow: 'rgba(33, 150, 243, 0.35)',
  },
  [STATUS_VARIANTS.REJECTED]: {
    label: 'Rejected',
    color: 'var(--workflow-red-local)',
    // shadow: 'rgba(255, 77, 77, 0.35)',
  },
  [STATUS_VARIANTS.IN_PROGRESS]: {
    label: 'In Progress',
    color: 'var(--workflow-yellow-regional)',
    // shadow: 'rgba(251, 140, 0, 0.35)',
  },
  [STATUS_VARIANTS.FAILED]: {
    label: 'Failed',
    color: 'var(--workflow-red-regional)',
    // shadow: 'rgba(255, 77, 77, 0.35)',
  },
  [STATUS_VARIANTS.PENDING_SUBMISSION]: {
    label: 'Pending Submission',
    color: 'var(--color-pending-sub-indicator)',
  },
  [STATUS_VARIANTS.FC_PENDING_APPROVAL]: {
    label: 'Pending Approval',
    color: 'var(--color-pending-app-indicator)',
  },
  [STATUS_VARIANTS.FC_APPROVED]: {
    label: 'Approved',
    color: 'var(--color-closed-indicator)',
  },
  [STATUS_VARIANTS.FC_REJECTED]: {
    label: 'Rejected',
    color: 'var(--color-cancel-indicator)',
  },
};

/**
 * Mapping of numeric status codes to status variants.
 */
export const STATUS_CODE_VARIANT_MAP = {
  0: STATUS_VARIANTS.PENDING,
  1: STATUS_VARIANTS.AWAITING,
  2: STATUS_VARIANTS.APPROVED,
  3: STATUS_VARIANTS.DISABLED,
};

/**
 * Default status variant to use if none is provided or matched.
 */
export const DEFAULT_STATUS_VARIANT = STATUS_VARIANTS.APPROVED;
